import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { closeCodePopup, checkCode, setCode as setCodeInStore } from "../../redux/actions";
import wheel from '../../images/wheel.png'
import lockedWheel from '../../images/lockedWheel.svg'
import loaderIcon from '../../images/loader.svg'

export const CodePopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const savedCode = useSelector(state => state.app.code)
    const id = useSelector(state => state.game.gameWheel.settings?.id)
    const price = useSelector(state => state.game.gameWheel.settings?.playPrice)
    const codePopup = useSelector(state => state.app.codePopup)
    const codePopupLoading = useSelector(state => state.app.codePopupLoading)

    const [code, setCode] = useState('');

    useEffect(() => {
        setCode(savedCode)
    }, [savedCode])

    function close() {
        setCodeInStore(code)
        dispatch(closeCodePopup())
    }

    if (!codePopup) return (null)
    else return (
        <div className="codePopup">
            <div className="codePopup__back" onClick={() => close()}></div>
            <div className="codePopup__wrap">
                <div className="codePopup__box">
                    <div className="codePopup__head">
                        {lang.games11}
                        <div className="codePopup__close" onClick={() => close()}>
                        </div>
                    </div>
                    <div className="codePopup__body">
                        <div className="code">
                            <div className="code__img">
                                <div className="code__wheel" >
                                    <img src={wheel} alt="" />
                                </div>
                                <div className="code__wheelLocked">
                                    <img src={lockedWheel} alt="" />
                                </div>
                            </div>
                            <div className="code__text">
                                {lang.games9 + price + lang.games10}
                            </div>
                            <form className="code__row" onSubmit={(event) => { event.preventDefault(); dispatch(checkCode(id, code)); }}>
                                <input onChange={(event) => { setCode(event.target.value) }} className="code__input" type="text" value={code} />
                                <button className="code__button">
                                    {
                                        codePopupLoading
                                            ? <img src={loaderIcon} alt="loader" />
                                            : lang.games8
                                    }
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}